// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2dpfk","title":"Header_title__3JE7G","left":"Header_left__RMZIs","clinicName":"Header_clinicName__2gDYI"};